export default {
  install(Vue, options) {
    Vue.mixin({
      data: function() {
        return {
          StringUtil: {

            // 去掉字符两端的空白字符
            Trim: function(_str) {
              return _str.replace(/(^[/t/n/r]*)|([/t/n/r]*$)/g, '');
            },

            // 去掉字符左边的空白字符
            LTrim: function(_str) {
              return _str.replace(/^[/t/n/r]/g, '');
            },

            // 去掉字符右边的空白字符
            RTrim: function(_str) {
              return _str.replace(/[/t/n/r]*$/g, '');
            },

            startWith: function(_str, _startStr) {
              return _str.indexOf(_startStr) === 0;
            },

            endWith: function(_str, _endStr) {
              return _str.lastIndexOf(_endStr) === _str.length - _endStr.length;
            },

            getName: function(_str) {
              return _str;
            },

            timestrapToStringInTable(row, column, cellValue){
              var dateObj = new Date(cellValue);
              var y = dateObj.getFullYear();
              var m = dateObj.getMonth() + 1;
              var d = dateObj.getDate();
              return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + dateObj.toTimeString().substr(0, 8);
            },

            timestrapToString(str){
              return new Date(str);
            },

            formatMysqlDatetime(str){
              if(str != null && str != undefined && str.lastIndexOf('.0') === str.length - 2){
                str = str.slice(0,-2);
              }
              return str;
            },
            
            formatMysqlDatetimeInTable(row, column){
              if(str != null && str != undefined && str.lastIndexOf('.0') === str.length - 2){
                str = str.slice(0,-2);
              }
              return str;
            },

            validateIdentity: function(str){
              var reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
              if (str.length === 15) {
                reg = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/;
              }
              return reg.test(str);
            },
            validateInt: function(str){
              var reg = /^[0-9]+$/;
              return reg.test(str);
            },
            validateMoney: function(str){
              var reg = /^[0-9]+\.[0-9]{2}$/;
              return reg.test(str);
            },
            validateFloatOne: function(str){
              var reg = /^[0-9]+\.[0-9]{1}$/;
              return reg.test(str);
            },
            validateFloat: function(str){
              var reg = /^[0-9]+\.[0-9]+$/;
              return reg.test(str);
            },
            validateEmail: function(str){
              var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
              return reg.test(str);
            },
            validateMobile: function(str){
              var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
              return reg.test(str);
            }


          }
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/StringUtil.js